// extracted by mini-css-extract-plugin
export var externalLink = "_ab-0";
export var internalLinkLabel = "_ab-1";